const ADBUTLER_URL = 'https://servedbyadbutler.com/adserve/';
const ADBUTLER_ID = '186107';

export const ZONE_IDS_INFO = {
	// Pickleball
	'946048': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'679340': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962468': {
		name: 'Homepage Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962469': {
		name: 'Players Page Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962470': {
		name: 'Players Details Pages Bottom of Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962471': {
		name: 'Watch Now Page Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962472': {
		name: 'Rankings Page Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962473': {
		name: 'Results Page Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'679331': {
		name: 'Small Card for All Pages House Ad',
		size: '300x250',
		width: 300,
		height: 250
	},
	'962474': {
		name: 'Small Card for All Pages Programmatic Ad',
		size: '300x250',
		width: 300,
		height: 250
	},
	'679332': {
		name: 'Long Card for All Pages House Ad',
		size: '300x600',
		width: 300,
		height: 600
	},
	'962475': {
		name: 'Long Card for All Pages Programmatic Ad',
		size: '300x600',
		width: 300,
		height: 600
	},
	'940896': {
		name: 'Homepage and Article Details Page Video Ad that goes to the bottom right corner when scrolled over',
		size: '640x360',
		width: 640,
		height: 360
	},
	'949638': {
		name: 'Homepage Video Ad that doesn’t go to the bottom right corner when scrolled over',
		size: '640x360',
		width: 640,
		height: 360
	},
	'962477': {
		name: 'Video Ad that plays video on entry and then finishes on static call to action',
		size: '640x360',
		width: 640,
		height: 360
	},
	'809175': {
		name: 'Modal Ad is a custom HTML advertisement for homepage',
		size: '0x0',
		width: 0,
		height: 0
	},
	// Pickleball Leagues
	'962487': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962488': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962489': {
		name: 'Search Page Content Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'688401': {
		name: 'Small Card for Search Page House Ad',
		size: '300x250',
		width: 300,
		height: 250
	},
	// Amateur Pickleball Rankings
	'962490': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962491': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962492': {
		name: 'Content of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	// Pickleball Tournaments
	'962493': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962494': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962495': {
		name: 'Content of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962497': {
		name: 'Small Card for All Pages House Ad',
		size: '300x250',
		width: 300,
		height: 250
	},
	'962499': {
		name: 'Long Card for All Pages House Ad',
		size: '300x600',
		width: 300,
		height: 600
	},
	'962501': {
		name: 'Long Card for All Pages Programmatic Ad',
		size: '300x600',
		width: 300,
		height: 600
	},
	'962502': {
		name: 'Homepage Video Ad that plays video on entry and then finishes on static call to action',
		size: '640x360',
		width: 640,
		height: 360
	},
	'962505': {
		name: 'Blog Details Page Video Ad that goes to the bottom right corner when scrolled over',
		size: '640x360',
		width: 640,
		height: 360
	},
	'788107': {
		name: 'Tournament Card Ad is a custom HTML advertisement for homepage and search page',
		size: '0x0',
		width: 0,
		height: 0
	},
	// Pickleball Clubs
	'962512': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962513': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962514': {
		name: 'Content of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	// Pickleball Team Leagues
	'962515': {
		name: 'Top of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962516': {
		name: 'Footer of All pages House Ad',
		size: '1280x130',
		width: 1280,
		height: 130
	},
	'962517': {
		name: 'Content of All Pages Programmatic Banner',
		size: '970x90',
		width: 970,
		height: 90
	},
	'962518': {
		name: 'Long Card for All Pages House Ad',
		size: '300x600',
		width: 300,
		height: 600
	},
	'962519': {
		name: 'Long Card for All Pages Programmatic Ad',
		size: '300x600',
		width: 300,
		height: 600
	}
} as const;

export { ADBUTLER_ID, ADBUTLER_URL };
